import { ID, WoosatTelecomResponse } from '../../../../../_metronic/helpers'

export type Supplier = {
  id?: any 
  supplier_name?: string         // Field for supplier name
  contact_details?: string       // Field for contact details
  address?: string               // Field for address
  status?: any               // Field for active/inactive status
}

export type SuppliersQueryResponse = WoosatTelecomResponse<Supplier[]>

export const initialSupplier: Supplier = {
  id: '',
  supplier_name: '',             // Default value for supplier name
  contact_details: '',           // Default value for contact details
  address: '',                   // Default value for address
  status: 1,                  // Default value set to true (active)
}
